import { useQuery } from '@tanstack/react-query';
import { strapiListAllSampleInformations } from '../../api/strapiCrm';
import { queryKeys } from '../queryKeys';

export function useSampleInformationsListQuery(jwt: string | null) {
  return useQuery({
    queryKey: queryKeys.sampleInformationsFlat(jwt),
    queryFn: () => strapiListAllSampleInformations(jwt!),
    enabled: Boolean(jwt),
  });
}
